<template>
  <div class="register financialAdvisorList">
<!--    导航条-->
    <div class="regAndSign">
      <div class="youXiao">
        <ul class="menuLis">
          <li class="">
            <a href="https://www.myfund.com/" target="_blank">
              <span>首页</span>
            </a>
          </li>
          <li>
            <a href="https://www.myfund.com/woodpecker.html" target="_blank">
              <span>啄木鸟</span>
            </a>
          </li>
          <li>
            <a href="https://www.myfund.com/aboutUs.html?type=map" target="_blank">
              <span>网站地图</span>
            </a>
          </li>
          <li v-if="$commonJs.getCookie('u_custno1') == '3261'">
            <a href="javascript:;">
              <span @click="$router.push({name:'liquidation'})">清算调账</span>
            </a>
          </li>
        </ul>
        <div class="conten">
          <div class="moKuai" v-show="custname">
            <img src="https://www.myfund.com/images/top-icon1w.png" alt="" />
            <img src="https://www.myfund.com/images/top-icon1w.png" alt="" />
            <span>{{'欢迎您，'+custname}}</span>
          </div>
          <div class="moKuai moKuaiExit" v-show="custname">
            <span style="margin-left: 0px;cursor: pointer;" @click="logout">安全退出</span>
          </div>
          <div class="moKuai" v-show="!custname">
            <img src="https://www.myfund.com/images/top-icon1w.png" alt="" />
            <img src="https://www.myfund.com/images/top-icon1w.png" alt="" />
            <span><a rel="nofollow" href="https://trade.myfund.com/personal/#/myAssets" target="_blank">个人登录</a></span>
          </div>
          <div class="moKuai" v-show="!custname">
            <img src="https://www.myfund.com/images/top-icon2w.png" alt="" />
            <img src="https://www.myfund.com/images/top-icon2w.png" alt="" />
            <span><a rel="nofollow" href="https://trade.myfund.com/kfit/page/cashcontrol/cashcontroltop.html"
                               target="_blank">机构登录</a></span>
          </div>
          <div class="moKuai">
            <img src="https://www.myfund.com/images/top-icon4w.png" alt="" />
            <span><a href="http://advisor.myfund.com/#/login" target="_blank">顾问登录</a></span>
          </div>
          <div class="moKuai">|</div>
          <div class="moKuai moKuai2">
            <img src="https://www.myfund.com/images/top-icon3w.png" alt="" />
            <img src="https://www.myfund.com/images/top-icon3w.png" alt="" />
            <span><a href="https://www.myfund.com/aboutUs.html" target="_blank">关于我们</a></span>
          </div>
        </div>
      </div>
    </div>
<!--    图片-->
    <div class="banner"></div>
<!--    搜索框-->
    <div class="search w">
      <div class="search-input clearfix">
        <input type="text" v-model="searchKey" id="adviserSearch" placeholder="请输入您的城市或理财顾问名字">
        <span @click="oneClickSearch">一键寻找</span>
      </div>
    </div>
<!--推荐顾问-->
    <div class="w con-box">
      <div class="recommend" v-show="!resultTitle">
        <p class="left">
          <span v-show="getBack" class="picture"></span>
          <span v-show="getBack">为您推荐</span>
        </p>
<!--        v-show="more"-->
        <span  class="right" @click="checkMore" v-show="seeMore">查看更多 ></span>
        <span class="right" @click="goHome" v-show="!getBack">返回 ></span>
      </div>
      <div class="recommend" v-show="resultTitle">
        <p class="left">
          <span class="seek">搜索结果：</span>
          <span class="place">{{keyword}}</span>
          <span class="result">共找到{{quantity}}位理财顾问！</span>
        </p>
        <span class="right" @click="goHome">返回 ></span>
      </div>
      <div class="counselor-box">
        <div class="synopsis" v-for="(val,index) in advisorList" :key="index+'jj'">
          <div class="left">
            <img :src="val.headPortrait == '--'?defaultAvatar:val.headPortrait" alt="">
<!--            todo 等待接口返回-->
            <button @click="leaveAMessage(val.adviserCode)">留 言</button>
            <button> <a :href="'https://www.myfund.com/consultantDetails.html?id=' + val.adviserCode" style="background:#fff;color: #236EAC;" target="_blank">了解更多</a>
            </button>
          </div>
          <div class="right">
            <div class="name"><span>{{val.adviserName}}</span><span></span></div>
            <div><span>地区</span>:<span>{{val.address}}</span></div>
            <div><span>从业时间</span>:<span>{{val.experiencetime}}年</span></div>
            <div><span>服务客户</span>:<span>{{val.customercount}}人</span></div>
            <div><span>优势</span>:<p class="advantage">{{val.serviceidea}}</p></div>
            <div><span>邮箱</span>:<span>{{val.email}}</span></div>
            <div><span>联系方式</span>:<span>{{val.phone}}</span></div>
          </div>
        </div>
      </div>
<!--      更多数据-->
      <el-pagination class="paging" v-show="!more"
        background
        layout="prev, pager, next" :page-size="pageSize" :current-page="page" @current-change="laypage"
        :total="totalNumber">
      </el-pagination>

    </div>
<!--    私募热销-->
    <div class="w hotPrivateFundBox clearfix">
      <div class="hotPrivateFundBox-img fl">
        <img src="../../assets/images/financialAdvisorList/investmentAdviser2.png" alt="">
      </div>
      <ul class="hotPrivateFundBox-ul clearfix fl" id="hotPrivateFunds">
        <li class="hotPrivateFundBox-ul-li" v-for="(item,index) in SMRXList" :key="index+'sm'">
          <p>
            <span class="sm-picture"></span>
            <a :href="'https://www.myfund.com/PrivateFund/' + item.fundCode + '.html'" class="hotPrivateFundBox-ul-li-tit bColor" target="_blank">{{item.fundName}}</a>
          </p>
          <div class="hotPrivateFundBox-ul-li-con">
            <p><span>最新净值：</span><span class="jz">暂无</span></p>
            <p><span>今年收益：</span><span class="isColor">{{item.thisYearYield?item.thisYearYield:'暂无'}}%</span></p>
            <p><span>累计收益：</span><span class="isColor">{{item.simYield?item.simYield:'暂无'}}%</span></p>
            <p><span>基金经理：</span><span class="jl">暂无</span></p>
            <p><span>基金公司：</span><span class="jz">暂无</span></p>
            <p><span>推荐理由：</span><span class="jl font14 tjly">{{item.reason?item.reason:'暂无'}}</span></p>
        </div>
          <div class="hotPrivateFundBox-ul-li-btn" @click="yuYue(item,true)">预约咨询</div>
        </li>
      </ul>
    </div>
<!--    客服电话-->
    <el-tooltip placement="left"  effect="light" :visible-arrow="false">
      <div slot="content"  class="phone">
          <span>平台客服</span></br>
          <span>400-818-8000</span>
      </div>
      <el-button class="customerService"></el-button>
    </el-tooltip>
<!--    弹框-->
    <el-dialog  :visible.sync="dialogTableVisible" :close-on-click-modal="false" :destroy-on-close="true" width="781" :show-close="false" :before-close="ClosePopUp">
        <div class="dialog-box">
          <img src="../../assets/images/financialAdvisorList/x0125-del.png" class="dialog-back" @click="ClosePopUp">

<!--          <img src="https://www.myfund.com/images/x0125-del.png" class="dialog-back" @click="dialogTableVisible = false">-->
          <p class="dialog-tit" style="color: #333;">联系理财顾问留言区</p>
          <form name="messageArea" id="messageArea" class="dialog-message">
            <!-- 上 -->
            <div class="clearfix">
              <textarea class="dialog-message-text fl" name="" id="leaveMessageDialogText" v-model="leaveWords.text" cols="30" rows="10" placeholder="请输入其他信息咨询留言"></textarea>
              <div class="dialog-message-radio fl">
                <p>1.您是展恒平台客户吗？</p>
                <div class="single">
                  <input type="radio" name="customer" v-model="leaveWords.isCustomer" value="是" id="customerYes" />
                  <label for="customerYes">是</label>
                  <input type="radio" name="customer" v-model="leaveWords.isCustomer" value="否"  style="margin-left: 14px;" id="customerNo" />
                  <label for="customerNo">否</label>
                </div>
                <p style="margin-top: 30px;">2.您合适的回访时间？</p>
                <div class="single">
                  <input type="radio" v-model="leaveWords.returnTime" value="上午" id="morning" />
                  <label for="morning">上午</label>
                  <input type="radio" v-model="leaveWords.returnTime" value="中午" id="noon" />
                  <label for="noon">中午</label>
                </div>
                <div class="single">
                  <input type="radio" v-model="leaveWords.returnTime" value="下午" id="afternoon" />
                  <label for="afternoon">下午</label>
                  <input type="radio" v-model="leaveWords.returnTime" value="晚上" id="night" />
                  <label for="night">晚上</label>
                </div>
              </div>
            </div>
            <!-- 下 -->
            <div class="dialog-info">
              <label for="">您的真实姓名：</label>
              <input type="text" id="customerName" v-model="leaveWords.customerName">
              <label for="">您的电话号码：</label>
              <input type="text" id="customerPnone" v-model="leaveWords.customerPnone">
            </div>
            <p class="dialog-con"> <span class="bColor">温馨提示：</span> 请保持您的手机畅通，理财顾问将于1~3个工作日内主动联系您！</p>
            <p id="leaveMessageError" v-show="leaveWords.leaveMessageError" class="rColor" style="margin: -19px 0 23px 241px;display: none;">请先完善以上信息在进行提交！</p>
            <div class="dialog-foot">
              <span id="messageAreaSubmit" target="_blank" @click="leaveMessageDialogSubmit()">提交</span>
            </div>
          </form>
      </div>
    </el-dialog>
<!--   预约咨询-->
    <zixunYuyue></zixunYuyue>
    <lvFooter></lvFooter>
  </div>
</template>

<script>
  import lvFooter from '@/components/lv-footer/lv-footer.vue';
  import zixunYuyue from "./zixunYuyue";
  const Base64 = require("js-base64").Base64;

  export default {
    name: "financialAdvisorList",
    components: {
      lvFooter,
      zixunYuyue
    },
    data(){
          return {
            custname:'',
            searchKey:'', //搜索框内容
            quantity:0, //搜索数量
            resultTitle:false,//搜索结果标题
            keyword:'',//搜索关键词
            page:1,//当前页数
            pageSize:3,//每页显示条数
            totalNumber:0,//总条数
            more:true, //查看更多
            advisorList:[], //顾问列表
            totalData:[],  //顾问总数据
            SMRXList:[], //私募热销
            dialogTableVisible:false,//留言弹框
            leaveWords:{//留言内容
              text:'',
              isCustomer:'',//是否展恒客户
              returnTime:'',//回访时间
              customerName:'',//姓名
              customerPnone:'',//电话号码
              leaveMessageError:false, //提示
              AdviserCode:'',//顾问工号
            },
            yyData:{
              show:false,//预约咨询是否显示
              wd:{}
            },
            defaultAvatar:"https://www.myfund.com/images/investmentAdviser22.png",//默认头像地址
            seeMore:true, //查看更多
            seekOff:false, //判断是否搜索
            getBack:true, //是否显示为您推荐
          }
    },
    mounted () {
        this.hotSellSM()
      this.recommend()
        //判断登录
      this.custname = this.$route.name == 'indexno' ? this.$commonJs.getCookie('register-phone') : Base64.decode(this.$commonJs.getCookie('u_name1'))
    },
    methods:{
      //返回首页
      goHome(){
        this.getBack = true
        this.resultTitle = false
        this.more = true
        this.seeMore = true
        this.recommend()
      },
      //分页查询
      laypage(val){
          //todo 判断是否搜索，
          this.seekOff?this.oneClickSearch(val):this.checkMore(val)
      },
      //预约
      yuYue(data,operation){
        console.log('测试12312',data)
        this.$set(this.yyData,'show',operation)
        this.$set(this.yyData,'wd',data)
      },
      //顾问推荐
      recommend(){
        const vm = this
        vm.$http.post(vm.$apiPath.GetAdvisorRemmondedList,{}
          ).then(res=>{
            console.log('查询1231结果1111',res)
            console.log('sousuo ',res)
            if(res.status == 200 && res.data.dataList.length != 0){
              let data = res.data.dataList
              vm.advisorList = [...data.slice(0,3)]
            }
          })
        },
          //热销
      hotSellSM(){
        const vm = this
        vm.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=getHotProductList',{}
        ).then(res=>{
          console.log('查询结果',res)
          if(res.status == 200 && res.data.list.length != 0){
            vm.SMRXList = [...res.data.list]
          }

        })
      },
        //更多
      checkMore(val){
        var vm = this
        if(typeof val == "number") this.page = val
        vm.pageSize = 9
        vm.$http.post(vm.$apiPath.GetAdvisorList,{
          pageid: vm.page, //页码
          getnumber: vm.pageSize //每页条数
        }).then(res=>{
          console.log('更多推荐列表',res)
          if(res.data.code == 200 && res.data.dataList.length > 0){
            vm.getBack = false //为您推荐是否显示
            vm.seeMore = false
            vm.advisorList = []
            vm.more = false
            let data = res.data.dataList
            vm.advisorList = [...data]
            vm.totalNumber = +res.data.tot
          }
        })
      },
      //退出登录
      logout () {
        window.sessionStorage.clear()
        this.$commonJs.delCookie('acticePath', '', -1)
        this.$commonJs.delCookie('sessionid', '', -1)
        this.$commonJs.delCookie('u_phone1', '', -1)
        this.$commonJs.delCookie('u_name1', '', -1)
        this.$commonJs.delCookie('u_id', '', -1)
        this.$commonJs.delCookie('Password', '', -1)
        this.$commonJs.delCookie('u_custno1', '', -1)
        this.$commonJs.setDomainCookie('u_name', '', -1)
        this.$commonJs.setDomainCookie('dct_Member', '', -1)
        this.$commonJs.setDomainCookie('u_risk', '', -1)
        this.$commonJs.setDomainCookie('u_custno', '', -1)
        this.$commonJs.setDomainCookie('u_phone', '', -1)
        this.$router.push({ name: 'login' })
      },
      //搜索
      oneClickSearch(val){
        if(this.searchKey == '')return this.$message.warning('请输入搜索内容')
        if(typeof val == "number") this.page = val
        const vm = this
        vm.pageSize = 9
        vm.$http.post(vm.$apiPath.SerchAdvisorList,{
          pageid:vm.page,//当前页数
          getnumber:vm.pageSize,//每页显示条数
          SerchString:vm.searchKey //搜索关键词
        }).then(res=> {
          console.log('查看搜索内容', res)
          if(res.status == 200 && res.data.dataList.length != 0){
            vm.seekOff = true
            let dataList = res.data.dataList;
            vm.advisorList = []
            vm.advisorList = [...dataList]  //页面需要显示条数
            vm.more = false
            vm.quantity = vm.totalNumber = +res.data.tot  //更多
            vm.resultTitle = true
            vm.keyword = vm.searchKey
          }else{
            vm.$message.error(res.data.note)
          }
        })
      },
      //留言
      leaveAMessage(code){
          this.$set(this.leaveWords,'AdviserCode',code)
          this.dialogTableVisible = true
      },

      // 联系理财顾问留言区
      leaveMessageDialogSubmit() {
        const vm = this
        if (vm.leaveWords.text == "" || vm.leaveWords.isCustomer == null || vm.leaveWords.returnTime == null || vm.leaveWords.customerName == "" || vm.leaveWords.customerPnone == "") {
          vm.$set(vm.leaveWords,'leaveMessageError',true)
        } else {
          vm.$set(vm.leaveWords,'leaveMessageError',false)
          let data = {
            command: 'AddedInvestmentAdviserMessage',
            adviserCode: vm.leaveWords.AdviserCode,  //顾问的AdviserCode
            custno: vm.$commonJs.getCookie('u_custno1'),
            userName: vm.leaveWords.customerName,
            message: vm.leaveWords.text,
            phone: vm.leaveWords.customerPnone,
            myfpCustomer: vm.leaveWords.customer,
            returnVisit: vm.leaveWords.returnTime
          }
          vm.$http.get('https://www.myfund.com/webinterface/Bamboo.ashx?command=AddedInvestmentAdviserMessage&adviserCode='+vm.leaveWords.AdviserCode+'&custno='+vm.$commonJs.getCookie('u_custno1')+
            '&userName='+ vm.leaveWords.customerName +'&message='+ vm.leaveWords.text + '&phone=' + vm.leaveWords.customerPnone + '&myfpCustomer='+vm.leaveWords.isCustomer+'&returnVisit='+ vm.leaveWords.returnTime,{}).then(res=>{
            console.log('查看是否成功',res)
            if (res.data.Result && res.data.Data.Note == "提交成功") {
              vm.$message.success('提交成功')
            } else {
              vm.$message.error('提交失败')
            }
            vm.ClosePopUp()
            vm.dialogTableVisible = false
          })
        }
      },

      //关闭弹框
      ClosePopUp(){
        console.log('关闭内容')
        this.dialogTableVisible = false
        this.leaveWords = {}
        this.leaveWords = {//留言内容
          text:'',
          isCustomer:'',//是否展恒客户
          returnTime:'',//回访时间
          customerName:'',//姓名
          customerPnone:'',//电话号码
          leaveMessageError:false, //提示
          AdviserCode:''//顾问工号
        }
      }
    },
  }
</script>

<style scoped lang="less">
.financialAdvisorList{
  background-color: @colorF2;
  .bColor{
    color: @color0C7AC1;
  }
  .menuLis{
    padding-top:0;
    line-height: 30px;
  }
  .regAndSign .youXiao .conten .moKuai:nth-child(4){
    top:0;
  }
  .regAndSign .youXiao .conten .moKuai:nth-child(4){
    width:auto;
  }
  .regAndSign .youXiao .conten .moKuai:nth-child(6){
    top:2;
  }
  .regAndSign .youXiao .conten .moKuai:nth-child(6){
    width:20px;
  }
  .banner{
    margin: 0 auto;
    height: 145px;
    background: url("../../assets/images/financialAdvisorList/investmentAdviser3.png") no-repeat center;
  }
  .search {
    position: relative;
    height: 210px;
    background: #fefefe;
    text-align: center;
    padding: 2px;
    .search-input {
      margin: 54px auto 26px;
      width: 802px;
      font-size: 20px;
      input {
        box-sizing: border-box;
        float: left;
        width: 609px;
        height: 60px;
        padding-left: 40px;
        border: 1px solid #A77011;
        border-radius: 30px 0 0 30px;
        font-size: 20px;
        outline: none;
      }
      input::-webkit-input-placeholder {
        color: #999;
        font-size: 20px;
      }
      span {
        display: block;
        float: left;
        width: 155px;
        height: 60px;
        line-height: 60px;
        background: #A77011;
        border-radius: 0 30px 30px 0;
        text-align: center;
        color: #FEFEFF;
        cursor: pointer;
      }
    }
    .search-option {
      box-sizing: border-box;
      width: 802px;
      margin: 0 auto;
      padding: 0 20px;
      li {
        position: relative;
        float: left;
        margin: 0 18px;
        font-size: 16px;
        cursor: pointer;
        font-weight: 600;
      }
    }
    .search_result {
      box-sizing: border-box;
      position: absolute;
      left: 226px;
      top: 117px;
      padding: 27px 20px 0;
      width: 583px;
      background: #fff;
      z-index: 999;
      box-shadow: 0 0 5px #c6c6c6;
      display: none;
      p {
        height: 45px;
        text-align: left;
        span:nth-child(1) {
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
        }
        span:last-child {
          position: absolute;
          right: 20px;
        }
      }
    }
  }
  .con-box{
    .recommend{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top:40px;
      .left{
        font-size: 20px;
        font-weight: bold;
        color: @color3;
        span{
          display: inline-block;
        }
        .picture{
          width: 5px;
          height: 20px;
          background: @color236;
          margin-right: 10px;
          transform: translateY(3px);
        }
        .seek{
          font-size: 20px;
          font-weight: 400;
          color: @color6;
          margin-left: 16px;
        }
        .place{
          display: inline-block;
          width: 73px;
          height: 30px;
          background: @colorE5;
          border-radius: 15px;
          font-size: 16px;
          font-weight: bold;
          color: @color3;
          margin: 0 21px 0 16px;
          text-align: center;
          line-height: 30px;
        }
        .result{
          font-size: 16px;
          font-weight: 400;
          color: @color3;
        }
      }
      .right{
        font-size: 16px;
        font-weight: 400;
        color: @color236;
        cursor: pointer;
      }
    }
    .counselor-box{
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      /*-moz-column-count:3; !* Firefox *!*/
      /*-webkit-column-count:3; !* Safari and Chrome *!*/
      /*column-count:3 ;*/
      /*column-width:384px;*/
      /*column-rule-width:24px;*/
      /*-webkit-column-rule-width: 24px;*/
      /*-webkit-column-span:all;*/
      /*column-fill: balance;*/

      margin-top:26px;
      .synopsis{
        -webkit-column-break-inside: avoid;
        width: 384px;
        height: 279px;
        background: @wColor;
        border-radius: 5px;
        padding: 16px 15px;
        margin-right: 24px;
        box-sizing: border-box;
        display: flex;
        margin-bottom: 26px;
        /*justify-content: space-between;*/
        .left{
          width:107px;
          text-align: center;
          img{
            width: 107px;
            height: 131px;
            background: #CCCCCC;
            border-radius: 10px;
            margin-bottom: 26px;
          }
          button{
            width: 89px;
            height: 30px;
            background: @color236;
            border-radius: 15px;
            color:@wColor;
            font-size: 14px;
            line-height: 30px;
            border:1px solid @color236;
            cursor: pointer;
          }
          button:last-child{
            background-color: @wColor;
            color: @color236;
            margin-top:14px;
          }
        }
        .right{
          padding-left: 13px;
          div{
            font-size: 14px;
            font-weight: 400;
            color: @color3;
            margin-bottom:10px;
            display: flex;
            >span:last-child{
             margin-left:12px;
              display: inline-block;
            }
          }
          div:last-child{
            margin-bottom: 0;
          }
          >div:not(:first-child){
            span:not(:last-child){
              display: inline-block;
              min-width:70px;
              text-align-last: justify;
              text-align: justify;
            }
          }
          .name{
            display: flex;
            align-items: flex-end;
            margin-bottom:17px;
            >span:first-child{
              font-size: 20px;
              font-weight: bold;
              margin-left: 0;
            }
            >span:last-child{
              font-size: 18px;
              font-weight: 400;
              margin-left: 13px;
            }

          }
          .advantage{
            max-width:157px;
            max-height:64px;
            line-height: 20px;
            margin-left: 12px;
            display: -webkit-box;
            -webkit-line-clamp:3;
            -webkit-box-orient:vertical;
            overflow: hidden;
          }
        }
      }
      .synopsis:nth-child(3n+0){
        margin-right: 0;
      }
    }
  }
  .hotPrivateFundBox {
    width: 1200px;
    height: 370px;
    margin: 40px auto 16px;
    .hotPrivateFundBox-img {
      margin-right: 18px;
      img{
        height:370px;
      }
    }

    .hotPrivateFundBox-ul {
      width: 1065px;
      height: 100%;
    }

    .hotPrivateFundBox-ul-li {
      position: relative;
      box-sizing: border-box;
      margin-right: 15px;
      padding: 25px;
      width: 345px;
      height: 100%;
      float: left;
      border: 1px solid #C8C8C8;
      border-top: 4px solid #0C7AC1;
      color: #333;
      background: #fff;
      .sm-picture{
        width: 3px;
        height: 16px;
        background: @color236;
        margin-right: 10px;
        transform: translateY(2px);
        display: inline-block;
      }
    }

    .hotPrivateFundBox-ul li:last-child {
      margin-right: 0;
    }

    .hotPrivateFundBox-ul-li-tit {
      padding-left: 10px;
      height: 18px;
      line-height: 18px;
      font-size: 18px;
      font-weight: bold;
      color:@color0C7AC1;
      font-weight: bold;
    }

    .hotPrivateFundBox-ul-li-con {
      font-size: 14px;
      margin:26px 0 23px;
      >p{
        display: flex;
        margin-bottom:10px;
        .jz{
          font-size: 16px;
          font-weight: 600;
          color: @color3;
        }
        .isColor{
          font-size: 16px;
          font-weight: 600;
          color: @colorD62121;
        }
        .jl{
          font-size: 16px;
          font-weight: 600;
          color: @color0C7AC1;
        }
        >span:first-child{
          min-width:70px;
        }
      }
      >p:last-child{
        margin-bottom: 0;
      }
      .font14{
        font-size: 14px!important;
      }
      .tjly{
        max-height:60px;
        line-height:20px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    /*.hotPrivateFundBox-ul-li-con p span:first-child {*/
    /*  float: left;*/
    /*  display: inline-block;*/
    /*}*/
    /*.hotPrivateFundBox-ul-li-con p span:last-child {*/
    /*  float: right;*/
    /*  width: 220px;*/
    /*  display: inline-block;*/
    /*}*/

    .hotPrivateFundBox-ul-li-btn {
      position: absolute;
      left: 25px;
      bottom: 26px;
      width: 293px;
      height: 36px;
      line-height: 36px;
      border: 1px solid #F3821E;
      color: #F3821E;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      cursor: pointer;
    }
  }
  /* 客服电话 */

  .customerService {
    position: fixed;
    top: 700px;
    right: 50%;
    margin-right: -680px;
    width: 45px;
    height: 45px;
    background: #fff url("../../assets/images/financialAdvisorList/investmentAdviser5.png") no-repeat center;
    cursor: pointer;
    z-index: 2;
    border-radius: 5px;
  }

  .paging{
    margin:20px auto 25px;
    text-align: center;
  }
  /deep/.el-pagination.is-background .btn-prev,/deep/.el-pagination.is-background .btn-next{
    width: 30px;
    height: 30px;
    background: @colorE7;
    border-radius: 3px;
    color:@color6;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: @color236;
  }

  /*留言*/
  .dialog-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
    display: none;
  }

  .dialog-box {
    input,textarea{
      outline: none;
    }
    input{
      border:none;

    }
    /*width: 318px;*/
    /*padding: 50px 66px;*/
    /*background: #fff;*/
    /*border-radius: 10px;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*left: 50%;*/
    /*z-index: 100;*/
    /*transform: translate(-50%, -50%);*/
  }

  .dialog-back {
    width: 30px;
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }

  .dialog-tit {
    font-size: 22px;
    font-weight: 700;
    color: #246ead;
    text-align: center;
  }

  .dialog-con {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #333;
    line-height: 20px;
    text-align: center;
  }
  .dialog-check {
    text-align: center;
    color: #236EAC;
  }

  .dialog-check input {
    vertical-align: middle;
    margin-right: 10px;
    border-color: #236EAC;
  }

  .dialog-foot {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }

  .dialog-foot button,
  .dialog-foot span {
    display: inline-block;
    width: 150px;
    height: 40px;
    border: 1px solid #246ead;
    border-color: #246ead;
    background-color: #246ead;
    color: #fff;
    cursor: pointer;
  }

  .dialog-message {
    padding: 36px 46px 0;
  }

  .dialog-message-text {
    box-sizing: border-box;
    padding: 20px;
    width: 437px;
    height: 179px;
    border: 1px solid #CFCFCF;
    resize: none;
    font-size: 16px;
  }

  .dialog-message-radio {
    padding-left: 30px;
  }

  .dialog-message-radio label {
    margin: 0 26px 34px 18px;
  }

  .dialog-message-radio .single {
    margin-top: 16px;
  }

  .dialog-info {
    margin: 25px 0;
  }

  .dialog-info input {
    background: #F1F1F1;
    width: 170px;
    height: 30px;
    margin-right: 40px;
    padding: 0 15px;
  }



}

</style>
